import { render, staticRenderFns } from "./WindowFlexible.vue?vue&type=template&id=3be971b7&scoped=true&"
import script from "./WindowFlexible.vue?vue&type=script&lang=js&"
export * from "./WindowFlexible.vue?vue&type=script&lang=js&"
import style0 from "./WindowFlexible.vue?vue&type=style&index=0&id=3be971b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be971b7",
  null
  
)

export default component.exports